import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CatalogsService } from "./catalogs.service";
import { CatalogsModel } from "./catalogs.model";

@Injectable()
export class CatalogsResolve implements Resolve<CatalogsModel> {
    constructor(private service: CatalogsService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<CatalogsModel> {
        return this.service
            .init()
            .then((result: CatalogsModel) => {
                return result;
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/catalogs/catalogs.resolve.ts